import React from 'react';
import { Loader2, CheckCircle2, RefreshCw } from 'lucide-react';

interface SignUpEmailVerificationFormProps {
  code: string;
  setCode: (val: string) => void;
  isLoading: boolean;
  resendCooldown: number;
  onVerify: (e: React.FormEvent) => void;
  onResend: () => void;
}

export const SignUpEmailVerificationForm: React.FC<SignUpEmailVerificationFormProps> = ({
  code,
  setCode,
  isLoading,
  resendCooldown,
  onVerify,
  onResend,
}) => {
  return (
    <form onSubmit={onVerify} className="space-y-4">
      <div>
        <label className="block text-xs font-medium text-zinc-300 mb-1.5">
          6-Digit Verification Code
        </label>
        <input
          type="text"
          required
          autoFocus
          maxLength={6}
          value={code}
          onChange={(e) => setCode(e.target.value.replace(/\D/g, ''))}
          placeholder="123456"
          className="w-full bg-zinc-950/70 border border-zinc-800 rounded-xl py-3 px-4 text-center tracking-widest text-lg font-mono text-white placeholder-zinc-600 focus:outline-none focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 transition"
        />
      </div>

      <button
        type="submit"
        disabled={isLoading || code.length < 6}
        className="w-full py-3 bg-indigo-600 hover:bg-indigo-500 text-white rounded-xl text-xs font-semibold transition flex items-center justify-center gap-2 shadow-lg shadow-indigo-600/20 cursor-pointer disabled:opacity-50"
      >
        {isLoading ? (
          <Loader2 className="w-4 h-4 animate-spin" />
        ) : (
          <>
            <CheckCircle2 className="w-4 h-4" />
            <span>Complete Registration</span>
          </>
        )}
      </button>

      <div className="text-center pt-2">
        <button
          type="button"
          onClick={onResend}
          disabled={isLoading || resendCooldown > 0}
          className="inline-flex items-center gap-1.5 text-xs text-zinc-400 hover:text-indigo-400 disabled:opacity-50 transition cursor-pointer"
        >
          <RefreshCw className="w-3.5 h-3.5" />
          <span>
            {resendCooldown > 0 ? `Resend code in ${resendCooldown}s` : 'Resend verification code'}
          </span>
        </button>
      </div>
    </form>
  );
};
